<template>
  <div>
    <div class="Fuell-Toolbar justify-content-between">
      <entity-search-input @search="fetchUsers"></entity-search-input>
      <div class="d-flex">
        <button
          class="Fuell-ToolbarButton mr-3 blue"
          @click="showCreateSuperBookKeeperModal"
        >
          <span
            class="Fuell-ToolbarButton--label"
            v-t="{path: 'users_create_super_book_keeper'}"
          >
          </span>
        </button>
        <button
          class="Fuell-ToolbarButton blue"
          @click="showCreateCommercialModal"
        >
          <span
            class="Fuell-ToolbarButton--label"
            v-t="{path: 'users_create_commercial'}"
          >
          </span>
        </button>
      </div>

    </div>
    <office-users-list-table @showUserActionsModal="showUserActionsModal"></office-users-list-table>
    <users-actions-modal
      v-if="showUserActionsModalFlag"
      :open.sync="showUserActionsModalFlag"
      :userId="userId"
      @refreshUsers="fetchUsers"
    ></users-actions-modal>
    <super-admin-create-commercial-modal
      :open.sync="showCreateCommercialModalFlag"
      v-if="showCreateCommercialModalFlag"
    ></super-admin-create-commercial-modal>
    <super-admin-create-super-book-keeper-modal
      v-if="showCreateSuperBookKeeperModalFlag"
      :open.sync="showCreateSuperBookKeeperModalFlag"
    ></super-admin-create-super-book-keeper-modal>
  </div>
</template>

<script>
import OfficeUsersListTable from '@/modules/users/_components/active/OfficeUsersUserListTable'
import EntitySearchInput from '@/components/Commons/Search/EntitySearchInput'
const UsersActionsModal = () => import('@/modules/users/_components/_shared/UserActionsModal')
const SuperAdminCreateCommercialModal = () => import('@/modules/users/_components/_shared/SuperAdminCreateCommercialModal')
const SuperAdminCreateSuperBookKeeperModal = () => import('@/modules/users/_components/_shared/SuperAdminCreateSuperBookKeeperModal')
export default {
  name: 'SuperAdminUserList',
  components: { OfficeUsersListTable, UsersActionsModal, SuperAdminCreateCommercialModal, EntitySearchInput, SuperAdminCreateSuperBookKeeperModal },
  data () {
    return {
      showUserActionsModalFlag: false,
      showCreateCommercialModalFlag: false,
      showCreateSuperBookKeeperModalFlag: false,
      userId: 0
    }
  },
  methods: {
    async fetchUsers (event) {
      let defaultFilters = {
        'status.statusType.code': ['ACTIVE', 'INVITE_BY_ADMIN', 'INVITE_BY_SUPER_ADMIN']
      }
      let searchFilters = {}
      if (event) {
        if (event.length < 3) return // Prevent multiple search calls s
        searchFilters.query = event
      }
      const filters = { ...defaultFilters, ...searchFilters }
      this.$store.dispatch('UsersStore/setUsersFilters', { filters: filters })
    },
    showUserActionsModal (event) {
      this.userId = event
      this.showUserActionsModalFlag = true
    },
    showCreateCommercialModal () {
      this.showCreateCommercialModalFlag = true
    },
    showCreateSuperBookKeeperModal () {
      this.showCreateSuperBookKeeperModalFlag = true
    }
  },
  async created () {
    this.fetchUsers()
  }
}
</script>
